import type { IconData } from '@stacksjs/iconify-core'

export const cg4x3: IconData = {
  "body": "<defs><clipPath id=\"SVG3j1JXXsi\"><path fill-opacity=\".7\" d=\"M-79.5 32h640v480h-640z\"/></clipPath></defs><g fill-rule=\"evenodd\" stroke-width=\"1pt\" clip-path=\"url(#SVG3j1JXXsi)\" transform=\"translate(79.5 -32)\"><path fill=\"#ff0\" d=\"M-119.5 32h720v480h-720z\"/><path fill=\"#00ca00\" d=\"M-119.5 32v480l480-480z\"/><path fill=\"red\" d=\"M120.5 512h480V32z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default cg4x3
